
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../App.css";
import Basic from "./Basic";
import Calibration from "./Calibration";
import ProductionByPart from "./ProductionByPart";
import SparesConsumables from "./SparesConsumables";

const AssetRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const assetData = location.state?.assetData || null;
  const [activeTab, setActiveTab] = useState("Basic");
  const [assetId, setAssetId] = useState(assetData?.AssetId || null);
  const userName = sessionStorage.getItem("userName");

 const [sparesData, setSparesData] = useState([]);
  const [sparesData1, setSparesData1] = useState([]);


  // Only Basic and Calibration are enabled
  const enabledTabs = ["Basic", "Calibration","Production by Part","Spares & Consumables"];

  const sections = [
    "Basic",
    "Calibration",
    "Production by Part",
    "Depreciation",
    "Insurance",
    "Spares & Consumables",
    "Financial Data",
    "Regular Users",
    "AMC",
  ];

  return (
    <div style={styles.container}>
      {/* Header Section */}
      <div style={styles.header}>
        <div style={styles.backLabel} onClick={() => navigate("/AssetregisterPageList")}>
          ← Back
        </div>

        <div style={{ width: "40px" }}></div>
        <h1 style={styles.title}>Asset Register</h1>
      </div>

      {/* Tabs */}
      <div style={styles.tabContainer}>
        {sections.map((section) => {
          const isEnabled = enabledTabs.includes(section);
          return (
            <button
              key={section}
              onClick={() => isEnabled && setActiveTab(section)}
              style={{
                ...styles.tab,
                ...(activeTab === section ? styles.activeTab : {}),
                ...(isEnabled ? {} : styles.disabledTab),
              }}
              disabled={!isEnabled}
            >
              {section}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div style={styles.tabContent}>
        {activeTab === "Basic" && (
          <Basic assetId={assetId} setAssetId={setAssetId} />
        )}

        {activeTab === "Calibration" && (
          <Calibration UserName={userName} AssetID={assetId} />
        )}

        
         {activeTab === "Production by Part" && (
          <ProductionByPart UserName={userName} AssetID={assetId} />
        )}

        {activeTab === "Spares & Consumables" && (
           <SparesConsumables
             UserName={userName}
             AssetID={assetId}
             sparesData={sparesData}
             setSparesData={setSparesData}
             sparesData1={sparesData1}
             setSparesData1={setSparesData1}
           />
         )}
        
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "1100px",
    margin: "15px auto",
    padding: "15px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    backgroundColor: "#f9f9f9",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "0",
  },
  backLabel: {
    padding: "4px 10px",
    backgroundColor: "#4686e5ff",
    color: "#fff",
    borderRadius: "6px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    transition: "all 0.2s",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  title: {
    flex: 1,
    textAlign: "center",
    fontSize: "24px",
    fontWeight: "600",
    color: "#1f2937",
    margin: "0 0 8px 0",
  },
  tabContainer: {
    display: "flex",
    gap: "8px",
    marginBottom: "15px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  tab: {
    padding: "6px 16px",
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    cursor: "pointer",
    backgroundColor: "#e5e7eb",
    fontWeight: "500",
    transition: "all 0.2s",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    fontSize: "14px",
  },
  activeTab: {
    backgroundColor: "#95949eff",
    color: "#fff",
    border: "1px solid #e1e1eeff",
    boxShadow: "0 1px 6px rgba(79, 70, 229, 0.3)",
  },
  disabledTab: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
  tabContent: {
    padding: "15px",
    border: "1px solid #d1d5db",
    borderRadius: "10px",
    backgroundColor: "#fff",
    boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
  },
};

export default AssetRegister;

// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import "../../App.css";
// import Basic from "./Basic";
// import Calibration from "./Calibration";

// const AssetRegister = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const assetData = location.state?.assetData || null;
//   const [activeTab, setActiveTab] = useState("Basic");
//   const [assetId, setAssetId] = useState(assetData?.AssetId || null);
//   const userName = sessionStorage.getItem("userName");

//   // Only Basic and Calibration are enabled
//   const enabledTabs = ["Basic", "Calibration"];

//   const sections = [
//     "Basic",
//     "Calibration",
//     "Depreciation",
//     "Insurance",
//     "Spares & Consumables",
//     "Financial Data",
//     "Regular Users",
//     "AMC",
//   ];

//   return (
//     <div style={styles.container}>
//       {/* Header Section */}
//       <div style={styles.header}>
//         <div style={styles.backLabel} onClick={() => navigate("/AssetregisterPageList")}>
//           ← Back
//         </div>

//         <div style={{ width: "40px" }}></div>
//         <h1 style={styles.title}>Asset Register</h1>
//       </div>

//       {/* Tabs */}
//       <div style={styles.tabContainer}>
//         {sections.map((section) => {
//           const isEnabled = enabledTabs.includes(section);
//           return (
//             <button
//               key={section}
//               onClick={() => isEnabled && setActiveTab(section)}
//               style={{
//                 ...styles.tab,
//                 ...(activeTab === section ? styles.activeTab : {}),
//                 ...(isEnabled ? {} : styles.disabledTab),
//               }}
//               disabled={!isEnabled}
//             >
//               {section}
//             </button>
//           );
//         })}
//       </div>

//       {/* Tab Content */}
//       <div style={styles.tabContent}>
//         {activeTab === "Basic" && (
//           <Basic assetId={assetId} setAssetId={setAssetId} />
//         )}

//         {activeTab === "Calibration" && (
//           <Calibration UserName={userName} AssetID={assetId} />
//         )}
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     maxWidth: "1100px",
//     margin: "15px auto",
//     padding: "15px",
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//     backgroundColor: "#f9f9f9",
//     borderRadius: "10px",
//     boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//   },
//   header: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     marginBottom: "0",
//   },
//   backLabel: {
//     padding: "4px 10px",
//     backgroundColor: "#4686e5ff",
//     color: "#fff",
//     borderRadius: "6px",
//     fontWeight: "600",
//     cursor: "pointer",
//     boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//     transition: "all 0.2s",
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//   },
//   title: {
//     flex: 1,
//     textAlign: "center",
//     fontSize: "24px",
//     fontWeight: "600",
//     color: "#1f2937",
//     margin: "0 0 8px 0",
//   },
//   tabContainer: {
//     display: "flex",
//     gap: "8px",
//     marginBottom: "15px",
//     flexWrap: "wrap",
//     justifyContent: "center",
//   },
//   tab: {
//     padding: "6px 16px",
//     borderRadius: "6px",
//     border: "1px solid #d1d5db",
//     cursor: "pointer",
//     backgroundColor: "#e5e7eb",
//     fontWeight: "500",
//     transition: "all 0.2s",
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//     fontSize: "14px",
//   },
//   activeTab: {
//     backgroundColor: "#95949eff",
//     color: "#fff",
//     border: "1px solid #e1e1eeff",
//     boxShadow: "0 1px 6px rgba(79, 70, 229, 0.3)",
//   },
//   disabledTab: {
//     opacity: 0.5,
//     cursor: "not-allowed",
//   },
//   tabContent: {
//     padding: "15px",
//     border: "1px solid #d1d5db",
//     borderRadius: "10px",
//     backgroundColor: "#fff",
//     boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
//   },
// };

// export default AssetRegister;

 